import { useMutation } from '@tanstack/react-query';
import { useToast } from 'components/Providers/ToastProvider';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

export const useCreateCustomization = () => {
    const { showMessage } = useToast();
    const { createCustomization } = useSearchAiPluginStore();
    return useMutation({
        mutationFn: createCustomization,
        onSuccess: () => showMessage('Success', 'Customization Created Successfully'),
        onError: (error) => showMessage('Error', error.message),
    });
};
